import { gql } from "@outschool/ui-apollo";
import { ChildFragment, FullCurrentUserFragment } from "@outschool/ui-auth";
import { LeaderFragment } from "@outschool/ui-components-website";

import { getLearnerItems } from "../components/enrolling/enrollmentForm/learnerItems/getLearnerItems";
import {
  CommonEnrollmentFormActivityFragment,
  CommonEnrollmentFormUserFragment,
} from "./ActivityEnrollQuery";
import LearnerFragment from "./LearnerFragment";

export const EnrollmentMeetingPurchaseQuery = gql`
  query EnrollmentMeetingPurchaseQuery(
    $activityUid: ID!
    $startTime: DateTime!
    $enrollmentUid: ID
    $meetingRequestUids: [ID!]
    $orgTeacherUid: ID
    $esaState: String
  ) {
    currentUser {
      ...CommonEnrollmentFormUserFragment
    }
    enrollmentMeetingPurchaseForm(
      activityUid: $activityUid
      startTime: $startTime
      enrollmentUid: $enrollmentUid
      meetingRequestUids: $meetingRequestUids
      orgTeacherUid: $orgTeacherUid
    ) {
      canPayLater
      activity {
        ...CommonEnrollmentFormActivityFragment
      }
      orgTeacher {
        ...LeaderFragment
      }
      learner {
        ...LearnerFragment
      }
      conflictingEnrollments {
        ...getLearnerItems_enrollment
      }
      pendingEnrollments {
        ...getLearnerItems_enrollmentWithMeetingPurchases
      }
      enrollmentsForActivityAndParent {
        ...getLearnerItems_enrollment
      }
      meetingRequests {
        uid
        start_time
        end_time
        is_recurring
        status
      }
    }
  }
  ${getLearnerItems.fragments.enrollmentWithMeetingPurchases}
  ${getLearnerItems.fragments.enrollment}
  ${ChildFragment}
  ${FullCurrentUserFragment}
  ${LeaderFragment}
  ${LearnerFragment}
  ${CommonEnrollmentFormUserFragment}
  ${CommonEnrollmentFormActivityFragment}
`;
